import { ReactNode, useMemo, useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import { Button } from '@/components/ui/button';
import { PassportPdf } from '@/pdf/PassportPdf';
import { PublicStructure } from '@/pdf/utils/pdfModel';

interface DownloadPassportButtonProps {
  publicStructure: PublicStructure;
  structureName?: string;
  className?: string;
  variant?: 'default' | 'outline' | 'secondary' | 'ghost';
  children?: ReactNode;
  disabled?: boolean;
}

const sanitizeFileName = (name: string): string =>
  name
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .replace(/_+/g, '_')
    .trim();

export const DownloadPassportButton = ({
  publicStructure,
  structureName,
  className,
  variant = 'outline',
  children,
  disabled,
}: DownloadPassportButtonProps) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const fileName = useMemo(() => {
    const safeName = sanitizeFileName(structureName || 'Struttura');
    const date = new Date().toISOString().slice(0, 10);
    return `Passaporto_${safeName}_${date}.pdf`;
  }, [structureName]);

  const onDownload = async () => {
    if (isGenerating) return;
    setIsGenerating(true);

    try {
      const doc = (
        <PassportPdf
          structure={{
            ...publicStructure,
            modules: publicStructure.modules || [],
          }}
        />
      );
      const blob = await pdf(doc).toBlob();

      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Button
      type="button"
      variant={variant}
      className={className}
      onClick={onDownload}
      disabled={true/* isGenerating || disabled */}
    >
      {isGenerating ? 'Generazione PDF...' : children || 'Scarica PDF'}
    </Button>
  );
};
